<template>
    <div>
      <!-- VIEW -->
      <v-container>
        <v-row class="ma-0">
          <v-col>
            <p class="headline text-center">Kebijakan Vendor</p>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="10">
            <v-card>
              <v-card-text>
                <v-form ref="frmProgram" v-model="valid">
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          label="Content"
                          v-model="form.kebijakanVendor.content"
                          outlined
                          rows="100"
                          hint="You can write multiple lines here"
                          persistent-hint
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-file-input 
                            label="File Attachment 1" 
                            v-model="form.uploadFile1" 
                            :placeholder="form.kebijakanVendor.file1" 
                            accept=".jpg,.png,.pdf" 
                            :append-icon="form.kebijakanVendor.file1 !== '' ? 'get_app' : ''"
                            @click:append="getLinkDownload(form.kebijakanVendor.file1)" 
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-file-input 
                            label="File Attachment 2" 
                            v-model="form.uploadFile2" 
                            :placeholder="form.kebijakanVendor.file3" 
                            accept=".jpg,.png,.pdf" 
                            :append-icon="form.kebijakanVendor.file3 !== '' ? 'get_app' : ''"
                            @click:append="getLinkDownload(form.kebijakanVendor.file3)" 
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-file-input 
                            label="File Attachment 3" 
                            v-model="form.uploadFile3" 
                            :placeholder="form.kebijakanVendor.file3" 
                            accept=".jpg,.png,.pdf" 
                            :append-icon="form.kebijakanVendor.file3 !== '' ? 'get_app' : ''"
                            @click:append="getLinkDownload(form.kebijakanVendor.file3)" 
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn dark color="green accent-3" @click="submitForm">Simpan</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- Notification -->
      <v-snackbar
          v-model="notification.show"
          :color="notification.color"
          :top="true"
          :right="true"
          :timeout=3000
      >
          {{ notification.text }}
      </v-snackbar>


      <v-dialog v-model="submitting" persistent max-width="600px">
          <v-card dark>
              <v-card-title>Sedang diproses</v-card-title>
              <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
          </v-card>
      </v-dialog>
      <v-dialog v-model="loginExpired" max-width="400" persistent>
          <v-card>
              <v-card-title>[401] Login Expired</v-card-title>
                  <v-card-text>Silakan Login Ulang</v-card-text>
              <v-card-actions>
                  <v-btn color="red" @click="logoutClick()">Ya</v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  const axios = require("axios").default;
  const apiUrl = process.env.VUE_APP_ROOT_API;
  
  export default {
    components: {
    },
    data() {
      return {
        valid: true,
        form : {
          kebijakanVendor: 
          {
            id: 1,
            content: "",
            file1: '',
            file2: '',
            file3: '',
            createdAt: null,
            updatedAt: null,
          },
          uploadFile1: null,
          uploadFile2: null,
          uploadFile3: null,
        },
        notification: {
            show: false,
            color: "success",
            text: ""
        },

        submitting: false,
        loginExpired: false
      };
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        axios
          .get(`${apiUrl}/api/kebijakan-vendor/${this.form.kebijakanVendor.id}`)
          .then((response) => {
            this.form.kebijakanVendor = Object.assign({}, response.data);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      submitForm() {
            let fdata = new FormData();
            fdata.append("id", this.form.kebijakanVendor.id);
            fdata.append("content", this.form.kebijakanVendor.content);
            fdata.append("file1", this.form.uploadFile1);
            fdata.append("file2", this.form.uploadFile2);
            fdata.append("file3", this.form.uploadFile3);

            this.submitting = true;

            axios.post(`${apiUrl}/api/kebijakan-vendor`, fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
            .then( (response) => {
                this.resetForm()
                this.form.kebijakanVendor = response.data;

                this.notification = {
                    show: true,
                    color: "success",
                    text: "Data kebijakan vendor berhasil disimpan"
                };

                this.closeForm();

            }).catch( (error) => {
                if(error.response.status == 401) {
                    this.loginExpired = true;
                }else {
                    this.notification = {
                        show: true,
                        color: "error",
                        text: `Gagal simpan data kebijakan vendor [${error.message}]`
                    };
                }
            }).finally( () => {
                this.submitting = false;

            });

        },
        getLinkDownload(dok) {
            axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = dok
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },
        resetForm() {
            this.form.uploadFile1 = null;
            this.form.uploadFile2 = null;
            this.form.uploadFile3 = null;

            this.form.kebijakanVendor = {
                id: 1,
                content: "",
                file1: "",
                file2: "",
                file3: "",
                createdAt: null,
                updatedAt: null,
            };
        },
    },
  };
  </script>
  
  <style scoped>
  .container {
    max-width: 100vw;
    padding: 0px;
  }
  </style>
  